<div style="height:calc(100vh - 235px);">
    <dx-data-grid #alertsGrid
                  height="100%"
                  hoverStateEnabled="true"
                  [dataSource]="dataSource"
                  [columnAutoWidth]="true"
                  (onEditingStart)="onEditingStart($event)"
                  (onOptionChanged)="onOptionChanged($event)">
        <dxo-editing mode="row"
                     [allowUpdating]="true"
                     [allowAdding]="false"
                     [allowDeleting]="true"
                     [useIcons]="true" />
        <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate" />
        <dxo-header-filter />
        <dxo-paging [enabled]="false" />
        <dxo-summary>
            <dxi-total-item column="displayName" [displayFormat]="'alerts.lblAlertsCount' | translate" summaryType="count" />
        </dxo-summary>
        <dxo-toolbar>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="onAddButtonClick($event)" />
                </div>
            </dxi-item>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="onRefreshButtonClick()" />
                </div>
            </dxi-item>
            <dxi-item name="searchPanel" />
        </dxo-toolbar>

        <dxi-column type="buttons" [width]="100">
            <dxi-button name="edit" />
            <dxi-button name="delete" />
        </dxi-column>
        <dxi-column dataField="displayName"
                    [allowEditing]="false"
                    [calculateCellValue]="displayRecipientName"
                    [caption]="'_commons.recipient' | translate" />
        <dxi-column dataField="notificationGroupName"
                    dataType="boolean"
                    [allowEditing]="false"
                    [caption]="'_commons.group' | translate"
                    [calculateCellValue]="isGroup"
                    [width]="100" />

        <!-- File transfer log types -->
        <dxi-column [caption]="'alerts.lblFileTransfersLogAlerts' | translate">
            <dxi-column dataField="TransferSucceeded"
                        dataType="boolean"
                        [calculateCellValue]="convertFileTransferLogTypeToBoolean"
                        [caption]="'alerts.lblTransferSucceeded' | translate"
                        [width]="100" />
            <dxi-column dataField="TransferFailed"
                        dataType="boolean"
                        [calculateCellValue]="convertFileTransferLogTypeToBoolean"
                        [caption]="'alerts.lblTransferFailed' | translate"
                        [width]="100" />
            <dxi-column dataField="ACKKOFileReceived"
                        dataType="boolean"
                        [calculateCellValue]="convertFileTransferLogTypeToBoolean"
                        [caption]="'alerts.lblAckKoFileReceived' | translate"
                        [width]="100" />
            <dxi-column dataField="ACKOKFileReceived"
                        dataType="boolean"
                        [calculateCellValue]="convertFileTransferLogTypeToBoolean"
                        [caption]="'alerts.lblAckOkFileReceived' | translate"
                        [width]="100" />
            <dxi-column dataField="NoACKReceived"
                        dataType="boolean"
                        [calculateCellValue]="convertFileTransferLogTypeToBoolean"
                        [caption]="'alerts.lblNoAckReceived' | translate"
                        [width]="100" />
            <dxi-column dataField="FileAlreadyExistsInTarget"
                        dataType="boolean"
                        [calculateCellValue]="convertFileTransferLogTypeToBoolean"
                        [caption]="'alerts.lblFileAlreadyExistsInTarget' | translate"
                        [width]="100" />
            <dxi-column dataField="ArchivedFileSentByEmail"
                        dataType="boolean"
                        [calculateCellValue]="convertFileTransferLogTypeToBoolean"
                        [caption]="'alerts.lblArchivedFileSentByEmail' | translate"
                        [width]="100" />
            <dxi-column dataField="EmptyFileIgnored"
                        dataType="boolean"
                        [calculateCellValue]="convertFileTransferLogTypeToBoolean"
                        [caption]="'alerts.lblEmptyFileIgnored' | translate"
                        [width]="100" />
            <dxi-column dataField="RealTimeDisconnected"
                        dataType="boolean"
                        [calculateCellValue]="convertFileTransferLogTypeToBoolean"
                        [caption]="'alerts.lblRealTimeDisconnected' | translate"
                        [width]="100" />
        </dxi-column>
        <!-- Remote platform log types -->
        <dxi-column [caption]="'alerts.lblRemotePlatformsLogAlerts' | translate">
            <dxi-column dataField="CredentialsError"
                        dataType="boolean"
                        [calculateCellValue]="convertRemotePlatformLogTypeToBoolean"
                        [caption]="'alerts.lblCredentialsError' | translate"
                        [width]="100" />
            <dxi-column dataField="TechnicalError"
                        dataType="boolean"
                        [calculateCellValue]="convertRemotePlatformLogTypeToBoolean"
                        [caption]="'alerts.lblTechnicalError' | translate"
                        [width]="100" />
            <dxi-column dataField="InvalidPublicKey"
                        dataType="boolean"
                        [calculateCellValue]="convertRemotePlatformLogTypeToBoolean"
                        [caption]="'alerts.lblInvalidPublicKey' | translate"
                        [width]="100" />
            <dxi-column dataField="InvalidCertificate"
                        dataType="boolean"
                        [calculateCellValue]="convertRemotePlatformLogTypeToBoolean"
                        [caption]="'alerts.lblInvalidCertificate' | translate"
                        [width]="100" />
        </dxi-column>
    </dx-data-grid>
</div>

<!-- RECIPIENT CREATION POPUP -->
<dx-popup [title]="'alerts.lblRecipientCreate' | translate" [(visible)]="showRecipientCreationPopup">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view direction="vertical" *ngIf="showRecipientCreationPopup">
            <dx-validation-group #recipientValidation>
                <div class="dx-field">
                    <div class="dx-field-label" translate>_commons.email<span class="dx-field-item-required-mark"> *</span></div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="newRecipientData.userId || newRecipientData.notificationGroupId"
                                     [(value)]="newRecipientData.emailAddress">
                            <dx-validator>
                                <dxi-validation-rule *ngIf="!newRecipientData.userId && !newRecipientData.notificationGroupId"
                                                     type="required" [message]="'alerts.required' | translate"></dxi-validation-rule>
                                <dxi-validation-rule *ngIf="!newRecipientData.userId && !newRecipientData.notificationGroupId"
                                                     type="email" [message]="'alerts.valInvalidEmail' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>_commons.employee<span class="dx-field-item-required-mark"> *</span></div>
                    <div class="dx-field-value">
                        <app-employee-picker [readOnly]="newRecipientData.emailAddress || newRecipientData.notificationGroupId"
                                             [isRequired]="!newRecipientData.emailAddress && !newRecipientData.notificationGroupId"
                                             (selectedItemChange)="newRecipientData.userId = $event.id" (selectionCleared)="newRecipientData.userId = null">
                        </app-employee-picker>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>_commons.group<span class="dx-field-item-required-mark"> *</span></div>
                    <div class="dx-field-value">
                        <dx-select-box [dataSource]="groups" displayExpr="name" [readOnly]="newRecipientData.emailAddress || newRecipientData.userId"
                                       [showClearButton]="true" (onSelectionChanged)="newRecipientData.notificationGroupId = $event.selectedItem ? $event.selectedItem.id : null">
                            <dx-validator>
                                <dxi-validation-rule *ngIf="!newRecipientData.userId && !newRecipientData.emailAddress"
                                                     type="required" [message]="'alerts.required' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>
                </div>
                <hr /><br />
                <div class="dx-field">
                    <div class="dx-field-label" translate>alerts.lblFileTransfersLogAlerts</div>
                    <div class="dx-field-value">
                        <dx-tag-box [dataSource]="fileTransferLogTypes" [displayExpr]="displayFileTransferLogType" [showClearButton]="true"
                                    [showSelectionControls]="true" [(selectedItems)]="newRecipientData.fileTransferLogTypesEnums"
                                    (onInitialized)="showTagBoxDropButton($event)">
                        </dx-tag-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>alerts.lblRemotePlatformsLogAlerts</div>
                    <div class="dx-field-value">
                        <dx-tag-box [dataSource]="remotePlatformLogTypes" [displayExpr]="displayRemotePlatformLogType" [showClearButton]="true"
                                    [showSelectionControls]="true" [(selectedItems)]="newRecipientData.remotePlatformLogTypesEnums"
                                    (onInitialized)="showTagBoxDropButton($event)">
                        </dx-tag-box>
                    </div>
                </div>
                <div class="flex bottom-buttons">
                    <dx-button class="save" [text]="'_commons.add' | translate" (onClick)="createRecipient()"></dx-button>
                    <dx-button class="delete" [text]="'_commons.cancel' | translate" (onClick)="showRecipientCreationPopup = false"></dx-button>
                </div>
            </dx-validation-group>
        </dx-scroll-view>
    </div>
</dx-popup>